/* eslint-disable brace-style, comma-dangle, max-len, no-var, object-curly-spacing, one-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var InfoTip = require("../components/info-tip.jsx");
var TextListEditor = require("../components/text-list-editor.jsx");

var NORMAL = "normal",
    AUTO = "auto",
    HORIZONTAL = "horizontal",
    VERTICAL = "vertical";

var OrdererEditor = React.createClass({
    displayName: "OrdererEditor",

    propTypes: {
        correctOptions: React.PropTypes.array,
        otherOptions: React.PropTypes.array,
        height: React.PropTypes.oneOf([NORMAL, AUTO]),
        layout: React.PropTypes.oneOf([HORIZONTAL, VERTICAL]),
        onChange: React.PropTypes.func.isRequired
    },

    getDefaultProps: function getDefaultProps() {
        return {
            correctOptions: [{ content: "$x$" }],
            otherOptions: [{ content: "$y$" }],
            height: NORMAL,
            layout: HORIZONTAL
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "perseus-widget-orderer" },
            React.createElement(
                "div",
                null,
                " ",
                "Correct answer:",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Place the cards in the correct order. The same card can be used more than once in the answer but will only be displayed once at the top of a stack of identical cards."
                    )
                )
            ),
            React.createElement(TextListEditor, {
                options: _.pluck(this.props.correctOptions, "content"),
                onChange: this.onOptionsChange.bind(this, "correctOptions"),
                layout: this.props.layout
            }),
            React.createElement(
                "div",
                null,
                " ",
                "Other cards:",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Create cards that are not part of the answer."
                    )
                )
            ),
            React.createElement(TextListEditor, {
                options: _.pluck(this.props.otherOptions, "content"),
                onChange: this.onOptionsChange.bind(this, "otherOptions"),
                layout: this.props.layout
            }),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    " ",
                    "Layout:",
                    " ",
                    React.createElement(
                        "select",
                        {
                            value: this.props.layout,
                            onChange: this.onLayoutChange
                        },
                        React.createElement(
                            "option",
                            { value: HORIZONTAL },
                            "Horizontal"
                        ),
                        React.createElement(
                            "option",
                            { value: VERTICAL },
                            "Vertical"
                        )
                    )
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Use the horizontal layout for short text and small images. The vertical layout is best for longer text (e.g. proofs)."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    " ",
                    "Height:",
                    " ",
                    React.createElement(
                        "select",
                        {
                            value: this.props.height,
                            onChange: this.onHeightChange
                        },
                        React.createElement(
                            "option",
                            { value: NORMAL },
                            "Normal"
                        ),
                        React.createElement(
                            "option",
                            { value: AUTO },
                            "Automatic"
                        )
                    )
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Use \"Normal\" for text, \"Automatic\" for images."
                    )
                )
            )
        );
    },

    onOptionsChange: function onOptionsChange(whichOptions, options, cb) {
        var props = {};
        props[whichOptions] = _.map(options, function (option) {
            return { content: option };
        });
        this.props.onChange(props, cb);
    },

    onLayoutChange: function onLayoutChange(e) {
        this.props.onChange({ layout: e.target.value });
    },

    onHeightChange: function onHeightChange(e) {
        this.props.onChange({ height: e.target.value });
    },

    serialize: function serialize() {
        // We combine the correct answer and the other cards by merging them,
        // removing duplicates and empty cards, and sorting them into
        // categories based on their content
        var options = _.chain(_.pluck(this.props.correctOptions, "content")).union(_.pluck(this.props.otherOptions, "content")).uniq().reject(function (content) {
            return content === "";
        }).sort().sortBy(function (content) {
            if (/\d/.test(content)) {
                return 0;
            } else if (/^\$?[a-zA-Z]+\$?$/.test(content)) {
                return 2;
            } else {
                return 1;
            }
        }).map(function (content) {
            return { content: content };
        }).value();

        return {
            options: options,
            correctOptions: this.props.correctOptions,
            otherOptions: this.props.otherOptions,
            height: this.props.height,
            layout: this.props.layout
        };
    }
});

module.exports = OrdererEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/orderer-editor.jsx
 ** module id = 133
 ** module chunks = 0 1
 **/